var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "background"
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-10 rounded-xl",
    attrs: {
      "id": "allContent"
    }
  }, [_c('div', {
    staticClass: "col-span-2 h-full bg-white rounded-l-xl px-4 pt-6 flex flex-col justify-between",
    attrs: {
      "id": "side"
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-6"
  }, [_c('div', {
    staticClass: "flex space-x-1.5 items-center text-blue-300 mb-6"
  }, [((_vm.personnal || {}).profile_image || {}).isDisplayed ? _c('profile-picture', {
    attrs: {
      "id": "photo",
      "size": "max-w-11 w-11 h-11",
      "supports-object-fit": false,
      "specific-url": ((_vm.personnal || {}).profile_image || {}).value || null
    }
  }) : _vm._e(), _vm._v(" "), _vm.personnal.prenom.isDisplayed || _vm.personnal.nom.isDisplayed ? _c('div', {
    staticClass: "font-medium text-base-0",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm.personnal.prenom.isDisplayed ? _c('span', [_vm._v("\n              " + _vm._s(_vm.personnal.prenom.value) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.personnal.nom.isDisplayed ? _c('span', [_vm._v("\n              " + _vm._s(_vm.personnal.nom.value))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _vm.personnal.adresse.value && _vm.personnal.adresse.isDisplayed && _vm.personnal.adresse.value != '' || _vm.personnal.email.value && _vm.personnal.email.isDisplayed && _vm.personnal.email.value != '' || _vm.personnal.telephone.value && _vm.personnal.telephone.isDisplayed && _vm.personnal.telephone.value != '' ? _c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('div', {
    staticClass: "text-2sm text-blue-600"
  }, [_vm._v("Coordonnées")]), _vm._v(" "), _c('icon', {
    staticClass: "text-red-400",
    class: {
      'pb-3': _vm.downloading
    },
    attrs: {
      "name": "chevron-down"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3.5"
  }, [_vm.personnal.date_naissance.value && _vm.personnal.date_naissance.isDisplayed && _vm.personnal.date_naissance.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "date_naissance"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "cake"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              Né le\n              " + _vm._s(new Date(_vm.personnal.date_naissance.value).toLocaleDateString()) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.adresse.value && _vm.personnal.adresse.isDisplayed && _vm.personnal.adresse.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "adresse"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "home-user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.personnal.adresse.value) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.telephone.value && _vm.personnal.telephone.isDisplayed && _vm.personnal.telephone.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "telephone"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "phone"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.personnal.telephone.value) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.email.value && _vm.personnal.email.isDisplayed && _vm.personnal.email.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1 flex-wrap",
    attrs: {
      "id": "email"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "envelope-open"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal flex flex-wrap",
    class: {
      'pb-3': _vm.downloading
    }
  }, _vm._l(_vm.splitedEmail, function (partMail, imail) {
    return _c('p', {
      key: 'partMail' + imail + partMail
    }, [_vm._v("\n                " + _vm._s(partMail) + "\n              ")]);
  }), 0)]) : _vm._e()]), _vm._v(" "), _vm.personnal.adresse.value && _vm.personnal.adresse.isDisplayed && _vm.personnal.adresse.value != '' || _vm.personnal.email.value && _vm.personnal.email.isDisplayed && _vm.personnal.email.value != '' || _vm.personnal.telephone.value && _vm.personnal.telephone.isDisplayed && _vm.personnal.telephone.value != '' ? _c('hr') : _vm._e(), _vm._v(" "), _vm.personnal.site_web.value && _vm.personnal.site_web.isDisplayed && _vm.personnal.site_web.value != '' || _vm.personnal.linkedin.value && _vm.personnal.linkedin.isDisplayed && _vm.personnal.linkedin.value != '' ? _c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('div', {
    staticClass: "text-2sm text-blue-600"
  }, [_vm._v("Web")]), _vm._v(" "), _c('icon', {
    staticClass: "text-red-400",
    class: {
      'pb-3': _vm.downloading
    },
    attrs: {
      "name": "chevron-down"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3.5"
  }, [_vm.personnal.site_web.value && _vm.personnal.site_web.isDisplayed && _vm.personnal.site_web.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "site_web"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "monitor"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.personnal.site_web.value) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.linkedin.value && _vm.personnal.linkedin.isDisplayed && _vm.personnal.linkedin.value != '' ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "linkedin"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "link"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.personnal.linkedin.value) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _vm.personnal.site_web.value && _vm.personnal.site_web.isDisplayed && _vm.personnal.site_web.value != '' || _vm.personnal.linkedin.value && _vm.personnal.linkedin.isDisplayed && _vm.personnal.linkedin.value != '' ? _c('hr') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-3.5"
  }, [_vm.personnal.moyen_transport.isDisplayed && _vm.personnal.moyen_transport.value.filter(function (m) {
    return !['Autres', 'Aucun'].includes(m);
  }).length > 0 ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "moyen_transport"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "truck"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              " + _vm._s(_vm.personnal.moyen_transport.value.filter(function (m) {
    return !['Autres', 'Aucun'].includes(m);
  }).join(', ')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _vm.personnal.travailleur_handicape.value && _vm.personnal.travailleur_handicape.isDisplayed ? _c('div', {
    staticClass: "flex items-center space-x-1",
    attrs: {
      "id": "travailleur_handicape"
    }
  }, [_c('div', {
    staticClass: "p-2 rounded-full bg-blue-10"
  }, [_c('icon', {
    staticClass: "text-blue-300 w-3 h-3",
    attrs: {
      "name": "file-user"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-2xs text-blue-600 font-normal",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n              RQTH\n            ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "w-full flex items-center justify-start py-3"
  }, [_c('icon', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "logo-neopass-dark-reduce"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 font-semibold text-lg",
    class: {
      'pb-6': _vm.downloading
    },
    attrs: {
      "font-family": "MADEEvolveSans-Bold, MADE Evolve Sans, Montserrat"
    }
  }, [_vm._v("\n            neopass\n          ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-8 rounded-r-xl px-5 pb-8",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "h-3/12 w-full"
  }, [_c('div', {
    staticClass: "relative mt-8 h-10/12 grid grid-cols-12 w-full",
    attrs: {
      "id": "title"
    }
  }, [_c('div', {
    staticClass: "col-span-3 relative"
  }, [_vm.typeDashboard === 'Dashboard' ? _c('illustration', {
    staticClass: "absolute -top-1.5",
    attrs: {
      "name": "cv-dashboard-homme"
    }
  }) : _vm._e(), _vm._v(" "), _vm.typeDashboard === 'Dashboard2' ? _c('illustration', {
    staticClass: "absolute -top-1.5",
    attrs: {
      "name": "cv-dashboard-femme"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-span-9 bg-white rounded-r-xl"
  }, [_c('div', {
    staticClass: "pl-28 pr-6 flex flex-col justify-center h-full space-y-1"
  }, [_c('div', {
    staticClass: "pl-2"
  }, [_c('div', {
    staticClass: "text-base-2 text-blue-300"
  }, [_vm._v("\n                  " + _vm._s(_vm.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs text-blue-600"
  }, [_vm._v("\n                  " + _vm._s(_vm.description != '' ? '“' + _vm.description + '”' : '') + "\n                ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "h-9/12 flex space-x-7 pb-5"
  }, [_c('div', {
    staticClass: "w-130 grid grid-cols-2 gap-x-3.5 gap-y-5"
  }, [_c('div', {
    staticClass: "col-span-2 grid grid-cols-2 h-48 gap-x-3.5"
  }, [_c('div', {
    staticClass: "col-span-1 bg-red-600 rounded-lg overflow-hidden h-full",
    class: {
      'p-3.5': !_vm.downloading,
      'px-3.5 py-1': _vm.downloading
    },
    attrs: {
      "id": "competences"
    }
  }, [_c('div', {
    staticClass: "flex flex-col h-full",
    class: {
      'space-y-1': !_vm.downloading
    }
  }, [_c('div', {
    staticClass: "flex justify-center space-x-1 items-center"
  }, [_c('div', {
    staticClass: "bg-red-300 p-1.5 rounded-full flex justify-center items-center"
  }, [_c('icon', {
    staticClass: "text-red-600 w-4 h-4",
    attrs: {
      "name": "check"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-red-300 text-base-2 font-medium",
    class: {
      'pb-4': _vm.downloading
    }
  }, [_vm._v("\n                    Compétences\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-sm text-red-300 flex flex-col space-y-0.5 items-center justify-center text-center h-full",
    class: {
      'pb-15': _vm.downloading
    }
  }, _vm._l(_vm.listCompetences, function (comp) {
    return _c('div', {
      key: comp.value + 'dashboard'
    }, [_vm._v("\n                    " + _vm._s(comp.value) + "\n                  ")]);
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 bg-white rounded-lg overflow-hidden h-full",
    class: {
      'p-3.5': !_vm.downloading,
      'px-3.5 py-1': _vm.downloading
    },
    attrs: {
      "id": "atouts"
    }
  }, [_c('div', {
    staticClass: "flex flex-col space-y-1 h-full"
  }, [_c('div', {
    staticClass: "flex justify-center space-x-1 items-center"
  }, [_c('div', {
    staticClass: "bg-blue-25 p-2.5 rounded-full flex justify-center items-center"
  }, [_c('icon', {
    staticClass: "text-blue-600 w-2.5 h-2.5",
    attrs: {
      "name": "person-add"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-blue-600 text-base-2 font-medium",
    class: {
      'pb-4': _vm.downloading
    }
  }, [_vm._v("\n                    Valeurs\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-sm text-blue-600 flex flex-col space-y-0.5 items-center justify-center text-center h-full",
    class: {
      'pb-15': _vm.downloading
    }
  }, _vm._l(_vm.listAtouts, function (atout) {
    return _c('div', {
      key: atout
    }, [_vm._v("\n                    " + _vm._s(atout) + "\n                  ")]);
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-start-1 col-span-2 h-40 bg-white rounded-xl p-3.5",
    attrs: {
      "id": "needs"
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-2 space-x-5"
  }, [_c('div', {
    staticClass: "flex flex-col space-y-2.5"
  }, [_c('p', {
    staticClass: "font-medium text-base-2 text-blue-300"
  }, [_vm._v("\n                  Besoins au travail\n                ")]), _vm._v(" "), _c('illustration', {
    attrs: {
      "name": "teamwork"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex items-center h-full"
  }, [_c('ul', {
    staticClass: "flex flex-col list-disc text-red-600 text-base-2 appearance-none",
    class: {
      'space-y-0': _vm.browser != 'firefox',
      'space-y-1': _vm.browser == 'firefox'
    }
  }, _vm._l(_vm.listNeeds, function (need) {
    return _c('li', {
      key: need
    }, [_c('div', {
      staticClass: "text-blue-300 text-xs",
      class: {
        'transform -translate-y-2': _vm.downloading && _vm.browser != 'firefox'
      }
    }, [_vm._v("\n                      " + _vm._s(need) + "\n                    ")])]);
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-start-1 col-span-2 h-28 grid grid-cols-3 gap-x-3.5 text-blue-600"
  }, _vm._l(_vm.hobbies.filter(function (h) {
    return h.isDisplayed;
  }), function (hobbie, ihobbie) {
    return _c('div', {
      key: 'hobbie' + ihobbie,
      staticClass: "bg-red-50 rounded-lg flex items-center py-2.5 px-4",
      attrs: {
        "id": 'hobbie' + ihobbie
      }
    }, [_c('div', {
      staticClass: "flex flex-col space-y-2 w-full",
      class: {
        'pb-3': _vm.downloading
      }
    }, [_c('div', {
      staticClass: "flex justify-between w-full items-center"
    }, [hobbie.image && hobbie.image != '' ? _c('img', {
      staticClass: "object-cover h-13 w-13 rounded-md",
      attrs: {
        "src": hobbie.image
      }
    }) : _vm._e(), _vm._v(" "), hobbie.icon && hobbie.icon != '' ? _c('div', {
      staticClass: "rounded-full bg-blue-600 p-2"
    }, [_c('icon', {
      staticClass: "text-white w-6 h-6",
      attrs: {
        "name": hobbie.icon
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "text-xs text-blue-300"
    }, [_vm._v("\n                  " + _vm._s(hobbie.value) + "\n                ")])])]);
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "w-4/10 grid grid-cols-2 gap-x-3.5 gap-y-7"
  }, [_c('div', {
    staticClass: "col-span-2 grid grid-cols-2 h-26 gap-x-3.5"
  }, [_c('div', {
    staticClass: "col-span-1 row-span-1 bg-blue-300 text-white rounded-xl relative p-2.5",
    attrs: {
      "id": "formation"
    }
  }, [_c('div', {
    staticClass: "absolute -top-5 left-4 p-2 bg-blue-25 rounded-full"
  }, [_c('icon', {
    staticClass: "text-blue-600",
    attrs: {
      "name": "certificate"
    }
  })], 1), _vm._v(" "), _vm.theFormation != null && _vm.theFormation != undefined ? _c('div', {
    staticClass: "flex flex-col items-center justify-center h-full",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_c('div', {
    staticClass: "text-center text-xs"
  }, [_vm._v("\n                  " + _vm._s(_vm.theFormation.value.value.intitule_parcours) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center text-xs"
  }, [_vm._v("\n                  " + _vm._s(_vm.niveauFormation) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 row-span-1 bg-blue-50 text-blue-600 rounded-xl relative p-2.5 flex items-center justify-center",
    class: {
      'pb-3': _vm.downloading
    },
    attrs: {
      "id": "langues"
    }
  }, [_c('div', {
    staticClass: "absolute -top-5 left-4 p-2 bg-blue-25 rounded-full"
  }, [_c('icon', {
    staticClass: "text-blue-400",
    attrs: {
      "name": "chats-dots"
    }
  })], 1), _vm._v(" "), _vm.langues.filter(function (l) {
    return l.isDisplayed;
  }).length > 0 ? _c('div', {
    staticClass: "flex flex-col items-center justify-center"
  }, _vm._l(_vm.langues.filter(function (l) {
    return l.isDisplayed;
  }), function (langue, ilangue) {
    return _c('div', {
      key: ilangue,
      staticClass: "text-center text-xs"
    }, [_vm._v("\n                  " + _vm._s(langue.value.name) + "\n                  " + _vm._s(_vm.niveaux[langue.value.niveau]) + "\n                ")]);
  }), 0) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-2 bg-white h-94 rounded-lg px-3.5 flex flex-col items-center shadow",
    class: {
      'py-0': _vm.isSucessIllustrationDisplayed && _vm.success.value.all,
      'py-4': !_vm.isSucessIllustrationDisplayed,
      'py-2': _vm.isSucessIllustrationDisplayed
    },
    attrs: {
      "id": "success"
    }
  }, [_c('div', {
    staticClass: "w-full h-full",
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm.isSucessIllustrationDisplayed && !_vm.success.value.all ? _c('illustration', {
    staticClass: "w-full",
    class: {
      'mb-1.5': !_vm.downloading
    },
    attrs: {
      "name": "illustration-cles-reussite"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isSucessIllustrationDisplayed && _vm.success.value.all ? _c('illustration', {
    staticClass: "w-full",
    class: {
      'mb-1.5': !_vm.downloading
    },
    attrs: {
      "name": "illustration-cles-reussite",
      "width": "268",
      "height": "326",
      "viewBox": "79 0 89 99"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.success.value.all && (_vm.sucessValues.workplace.length > 0 || _vm.sucessValues.conditions.length > 0 || _vm.sucessValues.teamwork.length > 0 || _vm.sucessValues.office.length > 0) ? _c('div', {
    staticClass: "flex flex-col p-1 px-4 h-full"
  }, [_c('div', {
    staticClass: "text-blue-300 text-base-2 mb-2"
  }, [_vm._v("\n                  Clés de réussite\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col h-full",
    class: {
      'space-y-2': !_vm.downloading && _vm.isSucessIllustrationDisplayed,
      'justify-around': !_vm.isSucessIllustrationDisplayed
    }
  }, [_vm.sucessValues.workplace.length > 0 ? _c('div', {
    staticClass: "flex items-center text-xs space-x-1 font-normal"
  }, [_c('div', {
    staticClass: "bg-red-600 p-2 rounded-full"
  }, [_c('icon', {
    staticClass: "text-red-300 w-2.5 h-2.5",
    attrs: {
      "name": "desktop"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.sucessValues.workplace.join(', ')[0].toUpperCase() + _vm.sucessValues.workplace.join(', ').slice(1)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm.sucessValues.conditions.length > 0 ? _c('div', {
    staticClass: "flex items-center text-xs space-x-1 font-normal"
  }, [_c('div', {
    staticClass: "bg-blue-600 p-2 rounded-full"
  }, [_c('icon', {
    staticClass: "text-white w-2.5 h-2.5",
    attrs: {
      "name": "clock-1"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.sucessValues.conditions.join(', ')[0].toUpperCase() + _vm.sucessValues.conditions.join(', ').slice(1)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm.sucessValues.teamwork.length > 0 ? _c('div', {
    staticClass: "flex items-center text-xs space-x-1 font-normal"
  }, [_c('div', {
    staticClass: "bg-blue-100 p-2 rounded-full"
  }, [_c('icon', {
    staticClass: "text-white w-2.5 h-2.5",
    attrs: {
      "name": "users-group"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.sucessValues.teamwork.join(', ')[0].toUpperCase() + _vm.sucessValues.teamwork.join(', ').slice(1)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _vm.sucessValues.office.length > 0 ? _c('div', {
    staticClass: "flex items-center text-xs space-x-1 font-normal"
  }, [_c('div', {
    staticClass: "bg-blue-50 p-2 rounded-full"
  }, [_c('icon', {
    staticClass: "text-white w-2.5 h-2.5",
    attrs: {
      "name": "grid-square-plus"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'pb-3': _vm.downloading
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.sucessValues.office.join(', ')) + "\n                    ")])]) : _vm._e()])]) : _vm._e()], 1)])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }